import { render } from "./KurzKresby2026.vue?vue&type=template&id=fcd84ec0"
import script from "./KurzKresby2026.vue?vue&type=script&lang=js"
export * from "./KurzKresby2026.vue?vue&type=script&lang=js"

import "./KurzKresby2026.vue?vue&type=style&index=0&id=fcd84ec0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__